<template>
    <div class="content">
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon"
                                                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                </van-col>
                <van-col span="12">
                    <img class="title-icon"
                         src="@/assets/theme/light/status/24deepSeek/01icon.svg">
                </van-col>
            </van-row>
        </div>
        <div class="ai-box" ref="markdownContent" >
            <div class="apply-value-parent">
                <div class="apply-value" @click="showReportBtn = true">
                    <div>
                        <div v-if="!aiAnalysis">{{ $t('deepSeek.analysis') }}</div>
                        <VueMarkdown :source="aiAnalysis" v-if="aiAnalysis"/>
                    </div>
                </div>
                <van-button
                    v-if="showReportBtn&&$i18n.locale === 'zh'"
                    class="report-btn"
                    type="warning"
                    size="mini"
                    plain
                    round
                    @click="goToReportPage(aiAnalysis)"
                >
                    举报
                </van-button>
                <img class="report-btn" @click="goToReportPage(aiAnalysis)" v-if="showReportBtn&&$i18n.locale !== 'zh'" src="@/assets/theme/light/status/24deepSeek/04report.svg">
            </div>
            <div v-for="item in ask">
                <div class="apply-key-parent" v-if="item.key">
                    <div class="apply-key" >
                        {{ item.key }}
                    </div>
                </div>
                <div class="apply-value-parent">
                    <div class="apply-value" @click="item.showReportBtn = true">
                        <div>
                            <img class="gif" src="@/assets/theme/light/status/24deepSeek/03.gif" v-if="!item.value">
                            <VueMarkdown :source="item.value" v-if="item.value"/>
                        </div>
                    </div>
                    <van-button
                        v-if="item.showReportBtn&&$i18n.locale === 'zh'"
                        class="report-btn"
                        type="warning"
                        size="mini"
                        plain
                        round
                        @click="goToReportPage(item.value)"
                    >
                       举报
                    </van-button>
                    <img class="report-btn" @click="goToReportPage(item.value)" v-if="item.showReportBtn&&$i18n.locale !== 'zh'" src="@/assets/theme/light/status/24deepSeek/04report.svg">
                </div>
            </div>
        </div>
        <div class="input-box">
            <div class="input-line">
                <van-field v-model="sendMsg" :placeholder="$t('deepSeek.placeholder')" />
                <img :class="{'band': !canAsk}" class="send" @click="askAI" src="@/assets/theme/light/status/24deepSeek/02send.png">
            </div>
            <div class="relief">{{$t('deepSeek.relief')}}</div>
        </div>
        <van-popup v-model="showReport" round position="bottom">
            <div class="report-box">
                <div class="report-title">{{$t('report.title')}}</div>
                <div class="muscles-box">
                    <div class="muscles-item" :class="{'active' : selectMuscles[index] == 1 }" v-for="(muscles, index) in reportTypeList" @click="clickMuscles(index)">{{muscles.show}}</div>
                </div>
                <div class="msg-box">
                    <van-field
                        v-model="message"
                        rows="6"
                        size="large"
                        type="textarea"
                        maxlength="100"
                        :placeholder="$t('report.content')"
                        show-word-limit
                    />
                </div>
                <div class="btn-disable" :class="{'able':message.length > 0}" @click="send">{{ $t('feedback.submit') }}</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import VueMarkdown  from "vue-markdown";
import {Toast} from "vant";
import {WebJSBridge} from "../../utils/JSBridge1";
export default {
    name: '24checkupDeepseek',
    components: { VueMarkdown },
    data() {
        return {
            theme: 'light',
            sendMsg: '',
            aiAnalysis: "",
            ask: [],
            askIndex: 0,
            canAsk: false,
            type: 0, // 0-体检，1-睡眠
            basicUrl: '',
            showReportBtn: false,
            showReport: false,
            selectMuscles: [0, 0, 0, 0, 0, 0, 0],
            reportTypeList: [
                {
                    type: 0,
                    name: '有害/不安全',
                    show: this.$t('report.type[0]')
                },
                {
                    type: 1,
                    name: '色情低俗',
                    show: this.$t('report.type[1]')
                },
                {
                    type: 2,
                    name: '谩骂攻击',
                    show: this.$t('report.type[2]')
                },
                {
                    type: 3,
                    name: '违法犯罪',
                    show: this.$t('report.type[3]')
                },
                {
                    type: 4,
                    name: '隐私相关',
                    show: this.$t('report.type[4]')
                },
                {
                    type: 5,
                    name: '侵犯我的著作权、名誉权等',
                    show: this.$t('report.type[5]')
                },
                {
                    type: 6,
                    name: '其他',
                    show: this.$t('report.type[6]')
                }
            ],
            reportContent: '',
            message: ''
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme
        }
        let url;
        if (window.location.hostname.indexOf('localhost') != -1) {
            url = 'http://localhost:5443/bdwatch_service';
        } else if (window.location.pathname.indexOf('debug') != -1) {
            url = 'https://service.beidouwatch.com:5443/bdwatch_service';
        } else {
            url = 'https://service.beidouwatch.com:4443/bdwatch_service';
        }
        this.basicUrl = url;
        if (this.$route.query.type == 0) {
            url = url + '/healthInfo/getCheckupAiAnalysis?id=' + this.$route.query.id + '&lang=' + this.$i18n.locale;
        } else if (this.$route.query.type == 1) {
            url = url + '/healthInfo/getSleepAiAnalysis?date=' + this.$route.query.date + '&lang=' + this.$i18n.locale;
        } else {
            url = url + '/healthInfo/getSportAiAnalysis?id=' + this.$route.query.id+ '&sportType=' + this.$route.query.sportType+ '&startSportTime=' + this.$route.query.startSportTime + '&lang=' + this.$i18n.locale;
        }
        this.getRespStream(url)
    },
    methods: {
        back() {
            if (this.$route.query.type == 2) {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            } else {
                this.$router.back()
            }

        },
        async getRespStream(url){
            const resp = await fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': localStorage.getItem('token')
                }
            });

            const reader = resp.body.getReader();
            while(1){
                // value 是类型化数组
                const textDecoder = new TextDecoder()
                const {done,value} = await reader.read();
                if(done){
                    this.canAsk = true;
                    if (this.$route.query.type == 2) {
                        WebJSBridge.call("updateSportAI", null, function (res) {
                        });
                    }
                    break
                }
                const str = textDecoder.decode(value)
                let lastScrollTime = 0;
                this.$nextTick(() => {
                    this.aiAnalysis += str;
                    if (Date.now() - lastScrollTime > 500) {
                        this.scrollToBottom();
                        lastScrollTime = Date.now();
                    }
                });
            }
        },
        scrollToBottom() {
            this.$nextTick(() => {
                setTimeout(() => {
                    const element = this.$refs.markdownContent;
                    element.scrollTop = element.scrollHeight;
                }, 300); // 适当延长延迟确保渲染完成
            });
        },
        askAI() {
            if (!this.canAsk) {
                Toast(this.$t('deepSeek.ing'))
                return
            }
            this.ask.push({
                key: this.sendMsg,
                value: '',
                showReportBtn: false
            });
            this.scrollToBottom();
            this.canAsk = false;
            this.getAskRespStream();
        },
        async getAskRespStream(){
            let lang = this.$i18n.locale;
            let langZh = lang.indexOf("zh") !== -1 ? "中文" :  lang.indexOf("en") !== -1 ? "英文" : "日文";
            let prompt = this.sendMsg + '用' + langZh + '回答'
            const url = this.basicUrl + '/healthInfo/getAI?prompt=' + prompt;
            const resp = await fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': localStorage.getItem('token')
                }
            });

            const reader = resp.body.getReader();
            while(1){
                // value 是类型化数组
                const textDecoder = new TextDecoder()
                const {done,value} = await reader.read();
                if(done){
                    this.askIndex++;
                    this.canAsk = true;
                    break;
                }
                const str = textDecoder.decode(value)
                this.sendMsg = ''
                let lastScrollTime = 0;
                this.$nextTick(() => {
                    this.ask[this.askIndex].value += str;
                    if (Date.now() - lastScrollTime > 500) { // 每500ms滚动一次
                        this.scrollToBottom();
                        lastScrollTime = Date.now();
                    }
                });
            }
        },
        goToReportPage(reportContent) {
            this.reportContent = reportContent;
            this.showReport = true;
            this.message = '';
            this.selectMuscles = [0,0,0,0,0,0,0]
        },
        clickMuscles(index) {
            if (this.selectMuscles[index] == 1) {
                this.$set(this.selectMuscles, index, 0);
            } else {
                this.$set(this.selectMuscles, index, 1);
            }
        },
        send() {
            let trainMuscles = [];
            for (let i = 0; i < this.selectMuscles.length; i++) {
                if (this.selectMuscles[i] == 1) {
                    trainMuscles.push(this.reportTypeList[i].name);
                }
            }
            if (this.message) {
                this.$api.my.uploadAppLog({
                    describe: this.reportContent + this.message,
                    reportType: trainMuscles.toString()
                }).then(res => {
                    Toast.success('提交成功');
                    this.showReport = false;
                })
            }
        }
    }
}
</script>

<style scoped>
.content {
    padding-top: 0;
}

.title-icon {
    width: 28px;
}

.apply-value-parent {
    justify-content: flex-start;
    padding-bottom: 20px;
    display: flex;
    position: relative;
    width: 340px;
    margin: 0 auto;
}

.apply-value {
    color: var(--text-color-1);
    font-size: 15px;
    border-radius: 22px 22px 22px 0;
    max-width: calc(100% - 68px);
    padding: 10px 15px;
    background-color: var(--bg-color-2);
}

.banner {
    position: fixed;
    top: 0;      /* 距离顶部0 */
    left: 0;     /* 距离左侧0 */
    width: 100%; /* 宽度100% */
    z-index: 100; /* 确保在其他内容上方 */
}

.ai-box {
    height: calc(100vh - 210px);
    overflow-y: auto;
    margin-top: 98px;
}

.input-box {
    width: 375px;
    height: 105px;
    background: var(--bg-color-2);
    box-shadow: 0px -2px 7px 1px rgba(177,201,228,0.16);
    border-radius: 20px 20px 0px 0px;
    position: fixed;
    bottom: -5px;      /* 距离顶部0 */
    left: 0;     /* 距离左侧0 */
    width: 100%; /* 宽度100% */
    z-index: 100; /* 确保在其他内容上方 */
}

.input-line {
    width: 345px;
    height: 41px;
    margin: 0 auto;
    padding-top: 21px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/deep/ input {
    background-color: var(--bg-color-1);
    font-size: 15px;
    border: none;
    padding: 10px 12px;
    border-radius: 11px 11px 11px 11px;
    color: var(--text-color-1);
}

.send {
    width: 40px;
}

.apply-key-parent {
    justify-content: flex-end;
    padding-bottom: 20px;
    display: flex;
    position: relative;
    width: 340px;
    margin: 0 auto;
}

.apply-key {
    background-color: var(--deepseek-color);
    font-size: 15px;
    border-radius: 22px 22px 0px 22px;
    max-width: calc(100% - 68px);
    padding: 10px 15px;
    color: var(--text-color-1);
}

.gif {
    width: 24px;
}

.band {
    opacity: 0.5;
}

.relief {
    color: var(--text-color-2);
    font-size: 15px;
    text-align: center;
    margin-top: 10px;
}

/deep/ .van-cell::after {
    border: none;
}

/deep/ .van-cell {
    background-color: var(--bg-color-2);
}

.report-btn {
    position: absolute;
    right: 0;
    bottom: 20px;
    margin-left: 8px;
    font-size: 12px;
}

.muscles-box {
    width: 345px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.muscles-item {
    background-color: var(--bg-color-1);
    color: var(--text-color-2);
    border-radius: 15px 15px 15px 15px;
    padding: 8px 14px;
    font-size: 12px;
    margin-right: 4px;
    margin-bottom: 8px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.muscles-item.active {
    background-color: #DAEDE5;
    color: #00BD9B;
}

.report-title {
    font-size: 15px;
    color: var(--text-color-1);
    text-align: center;
    margin-bottom: 20px;
}

.report-box {
    padding: 20px 0;
}

.msg-box {
    width: 345px;
    height: 189px;
    background: var(--bg-color-1);
    border-radius: 13px 13px 13px 13px;
    margin: 11px auto 0;
    overflow: hidden;
    font-size: 15px;
}

/deep/ .report-box .van-cell {
    padding: 16px 20px;
    background-color: var(--bg-color-1);
}

.btn-disable {
    width: 345px;
    height: 52px;
    background: var(--bg-color-1);
    border-radius: 13px 13px 13px 13px;
    margin: 10px auto;
    color: var(--text-color-3);
    justify-content: center;
    display: flex;
    align-items: center;
    font-size: 17px;
    border: 2px solid var(--bg-color-1);
}

/deep/ .van-field__control {
    font-size: 15px;
}

.able {
    border: 2px solid var(--line-color-4);
    color: var(--text-color-1);
}
</style>


// WEBPACK FOOTER //
// src/views/status/24checkupDeepseek.vue